import { render, staticRenderFns } from "./collapsible-question.vue?vue&type=template&id=5e993247&scoped=true&"
import script from "./collapsible-question.vue?vue&type=script&lang=ts&"
export * from "./collapsible-question.vue?vue&type=script&lang=ts&"
import style0 from "./collapsible-question.vue?vue&type=style&index=0&id=5e993247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e993247",
  null
  
)

export default component.exports